import React from 'react';
import { SvgIcon, useTheme } from '@mui/material';

import { INSURANCE_TYPE_DENTOLO, INSURANCE_TYPE_PETOLO, INSURANCE_TYPE_VITOLO } from '../shared';
import useInsuranceInfo from '../hooks/useInsuranceInfo';
import { PALETTE } from '../theme/palette';

function DentoloIcon(props) {
  const theme = useTheme();

  return (
    <SvgIcon inheritViewBox {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
      >
        <rect width="32" height="32" rx="7" fill={theme.palette.main.professional_blue} />
        <path
          d="M19.2677 9C20.4085 9 22.4622 9.9126 22.6905 12.6504C22.9187 15.3884 21.4604 18.306 20.8653 19.4961C20.1808 20.8651 19.0397 23.1462 18.127 23.1465C17.2143 23.1465 16.9861 22.234 16.7579 21.3213C16.531 20.4136 16.5296 18.6043 15.8565 18.584C15.1849 18.6067 15.1838 20.4142 14.9571 21.3213C14.729 22.2339 14.5004 23.1462 13.588 23.1465C12.6753 23.1465 11.5342 20.8652 10.8497 19.4961C10.2547 18.3061 8.79632 15.3885 9.0245 12.6504C9.25284 9.91292 11.3055 9.00019 12.4464 9C13.5837 9 14.4946 9.90643 15.8565 9.91211C17.2192 9.90705 18.13 9.00003 19.2677 9Z"
          fill={PALETTE.VITALIZED_GREEN}
        />
      </svg>
    </SvgIcon>
  );
}

function PetoloIcon(props) {
  const theme = useTheme();

  return (
    <SvgIcon inheritViewBox {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
      >
        <rect width="32" height="32" rx="7" fill={PALETTE.VITALIZED_ORANGE} />
        <path
          d="M11.1098 17.9786C11.8135 17.2968 11.5525 16.0101 10.5268 15.1045C9.50107 14.199 8.09906 14.0175 7.39532 14.6993C6.69157 15.3811 6.95258 16.6679 7.97832 17.5734C9.00404 18.479 10.406 18.6604 11.1098 17.9786Z"
          fill={theme.palette.main.professional_blue}
        />
        <path
          d="M24.7805 14.3752C25.2793 13.1709 24.8993 11.9169 23.9318 11.5741C22.9642 11.2314 21.7756 11.9297 21.2768 13.1339C20.778 14.3381 21.158 15.5922 22.1255 15.935C23.093 16.2777 24.2817 15.5794 24.7805 14.3752Z"
          fill={theme.palette.main.professional_blue}
        />
        <path
          d="M20.4534 10.7826C20.5757 9.33329 19.7199 8.08955 18.542 8.00459C17.3642 7.91962 16.3102 9.02561 16.188 10.4749C16.0658 11.9241 16.9215 13.1679 18.0994 13.2529C19.2772 13.3378 20.3312 12.2318 20.4534 10.7826Z"
          fill={theme.palette.main.professional_blue}
        />
        <path
          d="M13.7767 14.1297C14.7829 13.5783 14.942 12.1066 14.1321 10.8425C13.3221 9.5785 11.8499 9.00081 10.8436 9.55224C9.83742 10.1037 9.67833 11.5754 10.4883 12.8394C11.2982 14.1035 12.7705 14.6812 13.7767 14.1297Z"
          fill={theme.palette.main.professional_blue}
        />
        <path
          d="M21.7714 17.1073C20.7388 16.0467 19.4433 15.2788 18.0171 14.8819C17.3851 14.6838 16.7122 14.6546 16.0655 14.7973H16.048C15.4078 14.9402 14.8169 15.2501 14.3356 15.6956C13.2422 16.6516 12.4346 17.8912 12.0019 19.2774C11.5552 20.5767 11.6072 21.9956 12.1477 23.2587C12.214 23.4091 12.3095 23.5448 12.4286 23.658C12.5477 23.7713 12.6882 23.8597 12.8417 23.9183C12.9953 23.9769 13.159 24.0045 13.3232 23.9994C13.4875 23.9943 13.6492 23.9567 13.7988 23.8887C14.3385 23.6437 14.8402 23.3287 15.3741 23.075C16.0111 22.7477 16.6655 22.4556 17.3344 22.1999C17.4967 22.1425 17.6624 22.0948 17.8303 22.057C17.9978 22.0204 18.1673 21.9941 18.3379 21.9783C19.0581 21.9233 19.7807 21.9077 20.5025 21.9316C21.0859 21.9316 21.6956 22.0074 22.2907 21.9958C22.4532 21.9961 22.6141 21.9631 22.7633 21.8987C22.9125 21.8344 23.0469 21.7401 23.1582 21.6217C23.2695 21.5033 23.3553 21.3633 23.4104 21.2104C23.4653 21.0575 23.4884 20.895 23.478 20.7328C23.3707 19.3566 22.7638 18.0671 21.7714 17.1073Z"
          fill={theme.palette.main.professional_blue}
        />
      </svg>
    </SvgIcon>
  );
}

function VitoloIcon(props) {
  const theme = useTheme();

  return (
    <SvgIcon inheritViewBox {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
      >
        <rect width="32" height="32" rx="7" fill={PALETTE.VIBRANT_LIGHT_VIOLET} />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.5004 15.6429L16.2855 23L10.0706 15.6429V15.6335C7.44697 12.3158 9.0811 9.91892 10.8628 9.1768C14.0584 8.04641 16.1899 12.687 16.2855 13.1817C16.3812 12.687 18.5126 8.04641 21.7082 9.1768C23.4899 9.91892 24.7628 12.6842 22.5064 15.6335V15.6429H22.5004Z"
          fill={theme.palette.main.professional_blue}
          stroke={theme.palette.main.professional_blue}
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
}

export default function InsuranceTypeIcon() {
  const { type: insuranceType } = useInsuranceInfo();

  switch (insuranceType) {
    case INSURANCE_TYPE_DENTOLO:
      return <DentoloIcon />;
    case INSURANCE_TYPE_PETOLO:
      return <PetoloIcon />;
    case INSURANCE_TYPE_VITOLO:
      return <VitoloIcon />;
    default:
      return null;
  }
}
